// Steps: Actions triggered for each step/next button within the application.
import { Dispatch } from 'redux';

import { AppState } from '../../reducers';
import { trackEvent, TrackingStep } from '../../util/piwik-utils';
import { sendApplication } from '../application';
import {
    formApplicationCoApplicant,
    formApplicationMainApplicant,
    FormTypeApplicationCoApplicant,
    FormTypeApplicationMainApplicant,
} from '../forms';
import { fetchKycStatus } from '../kyc';
import { AppActions } from '../types';
import { openStep } from './steps';

/* Step 1 - Main Applicant */
export const loanApplicationMainApplicantNextEvent =
    (form: FormTypeApplicationMainApplicant) => async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        trackEvent(TrackingStep.MainApplicantInfo);
        dispatch(formApplicationMainApplicant(form));
        await fetchKycStatus(dispatch, getState);
        dispatch(openStep(4));
    };

/* Step 2 - Main Applicant - KYC */
export const loanApplicationMainApplicantKycNextEvent = () => (dispatch: Dispatch<AppActions>) => {
    trackEvent(TrackingStep.MainApplicantKyc);
    dispatch(openStep(5));
};

/* Step 3 - Co Applicant */
export const loanApplicationSecondApplicantNextEvent =
    (form: FormTypeApplicationCoApplicant) => async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        trackEvent(TrackingStep.SendApplication);
        const { hasCoApplicant } = getState().application;
        if (hasCoApplicant) dispatch(formApplicationCoApplicant(form));
        await sendApplication(dispatch, getState);
    };
export const loanApplicationSecondApplicantSkipNextEvent =
    () => async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        trackEvent(TrackingStep.SendApplication);
        await sendApplication(dispatch, getState);
    };
